// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.p2C6HiY9GL5aziCnsRNW {
	display: flex;
	flex-direction: column;
	position: relative;
}
@media not all and (max-width: 767px) {
.p2C6HiY9GL5aziCnsRNW {
		justify-content: center;
		padding-bottom: 50px;
}
	}
.mL7C5R_GqUIM_woxbc_K {
	display: flex;
	flex-direction: column;
	gap: 32px;
	padding: 32px;
}
.JGSc7QnMFpc7Kl1HmvUb {
	margin: 8px auto;
}
.nHGMohkpYDD1jdU1ZkPw {
	background: var(--gray);
	height: 44px;
	width: 44px;
}
.UK_xbDb24GDSHP4Fnt5u {
	display: flex;
	gap: 8px;
}
.r1C5U9_emKpT6neGuFt8 {
	box-sizing: border-box;
	font-size: 16px;
	letter-spacing: -0.08em;
	line-height: 28px;
	padding: 4px 26.5px;
	height: 36px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/VESISPage/VESISPage.pcss"],"names":[],"mappings":"AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,kBAAkB;AAMnB;AAJC;AALD;EAME,uBAAuB;EACvB,oBAAoB;AAEtB;CADC;AAGD;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,aAAa;AACd;AAEA;CACC,gBAAgB;AACjB;AAEA;CACC,uBAAuB;CACvB,YAAY;CACZ,WAAW;AACZ;AAEA;CACC,aAAa;CACb,QAAQ;AACT;AAEA;CACC,sBAAsB;CACtB,eAAe;CACf,uBAAuB;CACvB,iBAAiB;CACjB,mBAAmB;CACnB,YAAY;AACb","sourcesContent":["@import './../../stylesheets/media-queries.pcss';\n\n.page {\n\tdisplay: flex;\n\tflex-direction: column;\n\tposition: relative;\n\n\t@media not all and (--mobile) {\n\t\tjustify-content: center;\n\t\tpadding-bottom: 50px;\n\t}\n}\n\n.container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tgap: 32px;\n\tpadding: 32px;\n}\n\n.spinner {\n\tmargin: 8px auto;\n}\n\n.settings {\n\tbackground: var(--gray);\n\theight: 44px;\n\twidth: 44px;\n}\n\n.rightLinks {\n\tdisplay: flex;\n\tgap: 8px;\n}\n\n.goToRewardsButton {\n\tbox-sizing: border-box;\n\tfont-size: 16px;\n\tletter-spacing: -0.08em;\n\tline-height: 28px;\n\tpadding: 4px 26.5px;\n\theight: 36px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `p2C6HiY9GL5aziCnsRNW`,
	"container": `mL7C5R_GqUIM_woxbc_K`,
	"spinner": `JGSc7QnMFpc7Kl1HmvUb`,
	"settings": `nHGMohkpYDD1jdU1ZkPw`,
	"rightLinks": `UK_xbDb24GDSHP4Fnt5u`,
	"goToRewardsButton": `r1C5U9_emKpT6neGuFt8`
};
export default ___CSS_LOADER_EXPORT___;
